export const productBatchInfoTabs = [
	{
		name: 'Batch products',
		path: `product/product-batch/item/:id`,
	},
];
